export enum SIZE {
  XXS = "xxs",
  XS = "xs",
  SM = "sm",
  MD = "md",
  LG = "lg",
  XL = "xl",
}

export enum MONTH {
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}

export enum TEXT_ALIGN {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}

export enum Z_INDEX {
  MOBILE_STEPPER = 1000,
  FAB = 1050,
  SPEED_DIAL = 1050,
  APP_BAR = 1100,
  MODAL = 1200,
  DRAWER = 1300,
  SNACKBAR = 1400,
  TOOLTIP = 1500,
}

export enum DRAWER_MODE_OPTIONS {
  COLLAPSED = "collapsed",
  EXPANDED = "expanded",
  MOBILE = "mobile",
}

export enum AUTH_MODE {
  signIn = "signin",
  signUp = "signup",
}

export enum AUTH_USER_TYPE {
  USER = "user",
  EMPLOYEE = "employee",
}

export enum ASSESSMENT_MATCH_STORE_STATE {
  fetching = "fetching",
  closing = "closing",
  fetchSuccess = "fetch success",
  fetchFail = "fetch fail",
  closeSuccess = "close success",
  closeFail = "close fail",
  fetchMatchesSuccess = "fetch matches success",
}

export enum ASSESSMENT_TEMPLATE_STATE {
  fetching = "fetching",
  fetchSuccess = "fetch success",
  fetchFail = "fetch fail",
  fetchTemplatesSuccess = "fetch templates success",
}

export enum EMPLOYEE_STATE {
  fetching = "fetching",
  fetchSuccess = "fetch success",
  fetchFail = "fetch fail",
  fetchEmployeesSuccess = "fetch employees success",
  fetchEmployeesFail = "fetch employees fail",
}

export enum RATING_TYPE {
  one_to_five = "one_to_five",
  one_to_ten = "one_to_ten",
  free = "free",
}

export enum ASSESSMENT_CONFIGURATION_STEP {
  CREATE = "Create",
  DEFINE = "Define",
  SEND = "Send",
}

export enum ASSESSMENT_SEND_MODE {
  SINGLE = "single",
  GROUP = "group",
}

export enum ASSESSMENT_RESULTS_FILTERS {
  FILTER_BY_RESULTS = "filterByResults",
  FILTER_BY_PEOPLE = "filterByPeople",
}

export enum ASSESSMENT_TEMPLATE_TYPE {
  QUESTIONNAIRE = "Questionnaire",
  QUESTIONS = "Questions",
  EMPTY_BLOCKS = "Empty Blocks",
}
export enum ASSESSMENT_MONITORING_SECTION {
  OVERVIEW = "Overview",
  RESULT = "Result",
}

export enum GENERIC_STATE_STATUS {
  PENDING = "pending",
  FULFILLED = "fulfilled",
  REJECTED = "rejected",
}

export enum ASSESSMENT_EMPLOYEE_RELATIONSHIP {
  SELF = "self",
  MANAGER = "manager",
  CUSTOMER = "customer",
  REPORT = "report",
  PEER = "peer",
  GENERIC_COLLEAGUE = "generic_colleague",
  NO_SELF = "no_self",
}

export enum MAGIC_LINK_VALIDATION_ERROR {
  JWT_VALIDATION_FAILED = "JWT_VALIDATION_FAILED",
  TOKEN_IS_EXPIRED = "TOKEN_IS_EXPIRED",
  STATE_NOT_VALID = "STATE_NOT_VALID",
  MATCH_ALREADY_COMPLETED = "MATCH_ALREADY_COMPLETED",
  EMPLOYEE_NOT_FOUND = "EMPLOYEE_NOT_FOUND",
  USER_NOT_FOUND = "USER_NOT_FOUND",
}

export enum AUTH_CHECK_ROUTE {
  FEEDBACK_SUBMISSION = "feedback",
  DASHBOARD = "dashboard",
}

export enum ASSESSMENT_STATE {
  COMPLETED = "completed",
  NOT_COMPLETED = "incomplete",
  PLANNED = "planned",
  DRAFT = "draft",
}

export enum ASSESSMENT_MATCH_STATE {
  COMPLETED = "completed",
  NOT_COMPLETED = "incomplete",
}

export enum USER_STATE {
  ACTIVE = "active",
  PENDING = "pending",
}

export enum USER_ROLE {
  COMPANY_ADMIN = "company_admin",
  COMPANY_USER = "company_user",
}

export enum SCORE {
  EXCELLENT = 90,
  VERY_GOOD = 80,
  GOOD = 60,
  POOR = 0,
}

export enum ERROR_CODE {
  AM004 = "AM004",
}

export enum ASSESSMENT_EVALUATOR_TYPE {
  EMPLOYEE = "employee",
}

export enum DEVELOPMENT_PLAN_STATUS {
  ALL = "all",
  COMPLETED = "completed",
  NOT_COMPLETED = "notCompleted",
}

export enum CURRENT_STATE {
  IDLE = "idle",
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}
